function TestimonialCard({ name, text, avatar }) {
  return (
    <article className="testimonial-card">
      <div className="reviwe-img-container">
      <img src={avatar} alt={name} className="reviwe-img"/>
      </div>
      <h3 className="reviwe-name">{name}</h3>
      <p>{text}</p>
    </article>
  );
}
export default TestimonialCard;
